import { useMemo } from 'react';

import { filterMenuByRole, transformModuleConfig, type MenuItemConfig } from '@/config/navigation';
import type { MenuItem } from '@/consts/navigation';
import { useAuthStore } from '@/stores/useAuthStore';
import { useShallow } from 'zustand/react/shallow';

interface UseRoleBasedMenuOptions {
  menuConfigs: MenuItemConfig[];
}

export const useRoleBasedMenu = ({ menuConfigs }: UseRoleBasedMenuOptions): MenuItem[] => {
  const { user } = useAuthStore(
    useShallow((state) => ({
      user: state.user
    }))
  );

  const userRoles = useMemo(() => {
    if (!user?.Roles) return [];
    return user.Roles.map((role) => role.Id);
  }, [user?.Roles]);

  return useMemo(() => {
    // Filter menu based on user roles
    const filteredConfigs = filterMenuByRole(menuConfigs, userRoles);

    // Transform to MenuItem format
    return transformModuleConfig(filteredConfigs);
  }, [menuConfigs, userRoles]);
};
